/* if the splash is intended to be used as a secondary splash (soft navigation),
   then `processSplash` must take 'true' as the last argument (which will make its display none) */
function processSplash(
    html: string,
    css: string,
    hidden?: boolean,
    brandInfo?: Array<{
        name: string;
        html: string;
    }>,
) {
    const styles = `${
        hidden ? 'display: none;' : ''
    } position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 1000;`;

    let wrapper = `<div style="${styles}" class='bootstrap-splash protected'  data-brand="dazn" >${html}<style>${css}</style></div>`;

    const brandWrapper = brandInfo
        ? brandInfo.reduce(
              (acc, brandContent) =>
                  `<div style="${styles}" class='bootstrap-splash protected' data-brand="${brandContent.name}">${brandContent.html}<style>${css}</style></div>` +
                  acc,
              ``,
          )
        : '';

    wrapper += brandWrapper;

    return wrapper.replace(/(\n | \s)/g, '');
}

export { processSplash };
